var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var CheckmarkCircle2 = function CheckmarkCircle2(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.997 10.974H21a1 1 0 0 1 1 .997 9.932 9.932 0 0 1-2.909 7.08 9.935 9.935 0 0 1-7.062 2.95H12a9.932 9.932 0 0 1-7.051-2.91A9.935 9.935 0 0 1 2 12.03a9.93 9.93 0 0 1 2.909-7.08A9.934 9.934 0 0 1 11.971 2c.795.012 1.605.092 2.381.278a1 1 0 0 1-.469 1.945A8.817 8.817 0 0 0 11.977 4a7.946 7.946 0 0 0-5.65 2.36A7.947 7.947 0 0 0 4 12.022a7.948 7.948 0 0 0 2.359 5.65A7.949 7.949 0 0 0 12 20h.023a7.946 7.946 0 0 0 5.65-2.359A7.949 7.949 0 0 0 20 11.977a1 1 0 0 1 .997-1.003Zm-12.704.319a.999.999 0 0 1 1.414 0l2.244 2.244 6.297-7.196a1 1 0 0 1 1.504 1.318l-7 8a1.002 1.002 0 0 1-.719.341H12a1 1 0 0 1-.707-.293l-3-3a.999.999 0 0 1 0-1.414Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default CheckmarkCircle2;